import "./VariablesManager.css";
import VariableBlock from "./VariableBlock/VariableBlock";
import Button from "/src/components/UI/Button/Button";
import NiceModal  from "@ebay/nice-modal-react";
import VariableEdition from "./VariableEdition/VariableEdition";
import { useBotStateContext } from "../../../contexts/BotContext";
import editorAction from "../../../actions/editorAction";
import AreaList from "../../Form/UI/AreaList/AreaList";
import AreaListData from "../../Form/UI/AreaListData/AreaListData";

// List of all the variable's in the bot, throught the AreaList
function VariablesManager() {

    const { variables } = useBotStateContext();
    const { addVariable } = editorAction();

    const onClick = async () => {
       const data = await NiceModal.show('editor-popup', { Component : VariableEdition });
       // Wait the modal variable creation
       addVariable(data)
    }

    return (
        <>
            <label className="title title_variable">Variable Manager</label>
            <label className="sub_title">Custom variables</label>
            <AreaList title="Variables" buttonLabel="Create a variable" maxHeight="550px" onClickButton={onClick}>
                <AreaListData data={variables} ComponentRow={VariableBlock}></AreaListData>
            </AreaList>
        </>
    )
}

export default VariablesManager;